import React from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Container,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Hidden,
    Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { joinAsFullName } from "../../utils/commonUtils";

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: "#081018",
        padding: theme.spacing(1),
    },
    root: {
        display: "flex",
        flexDirection: "row",
        padding: 0,
        color: "#fff",
    },
    item: {
        width: "auto",
        paddingRight: theme.spacing(3),
    },
    icon: {
        minWidth: 32,
        color: "#fff",
    },
    text: {
        color: "#fff",
    },
}));

const TopHeader: React.FC = () => {
    const classes = useStyles();

    const verifyInviteData = useSelector((state: RootState) => state.verify);
    const agentName = verifyInviteData && verifyInviteData.client && verifyInviteData.client.agent && verifyInviteData.client.agent.user && verifyInviteData.client.agent.user;
    const phoneNumber = verifyInviteData && verifyInviteData.client && verifyInviteData.client.agent && verifyInviteData.client.agent.user && verifyInviteData.client.agent.user.phoneNumber;
    const agentEmail = verifyInviteData && verifyInviteData.client && verifyInviteData.client.agent && verifyInviteData.client.agent.user && verifyInviteData.client.agent.user.email;
   console.log("phoneNumber", { agentEmail, phoneNumber });


    return (
            <AppBar position="static" className={classes.appBar}>
                <Container maxWidth="lg">
                    <Toolbar style={{ justifyContent: "space-between" }}>
                        {/* Desktop & Tablet Layout */}
                        <Hidden smDown>
                            <>
                                <Typography variant="body1" style={{ color: "#fff" }}>
                                    Discover the benefits of an IUL with {joinAsFullName(agentName)}
                                </Typography>
                                <List className={classes.root}>
                                    <ListItem className={classes.item}>
                                        <ListItemIcon className={classes.icon}>
                                            <PhoneIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText
                                                primary={phoneNumber}
                                                primaryTypographyProps={{
                                                    variant: "body2",
                                                    className: classes.text,
                                                }}
                                        />
                                    </ListItem>

                                    <ListItem className={classes.item}>
                                        <ListItemIcon className={classes.icon}>
                                            <EmailIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText
                                                primary={agentEmail}
                                                primaryTypographyProps={{
                                                    variant: "body2",
                                                    className: classes.text,
                                                }}
                                        />
                                    </ListItem>
                                </List>
                            </>
                        </Hidden>

                        {/* Mobile Layout */}
                        <Hidden mdUp>
                            <Box display="flex" flexDirection="column" width="100%">
                                <Typography
                                        variant="body2"
                                        style={{ color: "#fff", marginBottom: 8 }}
                                >
                                    Discover the benefits of an IUL with {agentName}
                                </Typography>
                                <Box display="flex" flexDirection="column">
                                    <Box display="flex" alignItems="center" mb={1}>
                                        <PhoneIcon fontSize="small" style={{ color: "#fff", marginRight: 8 }} />
                                        <Typography variant="body2" style={{ color: "#fff" }}>
                                            {phoneNumber}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center">
                                        <EmailIcon fontSize="small" style={{ color: "#fff", marginRight: 8 }} />
                                        <Typography variant="body2" style={{ color: "#fff" }}>
                                            {agentEmail}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Hidden>
                    </Toolbar>
                </Container>
            </AppBar>
    );
};

export default TopHeader;
